import NFA from 'shared/helpers/analytics/NFAnalytics';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { MULTI_SELLER_POPUP_OPEN, SELLER_DETAILS_POPUP_OPEN } from 'shared/constants/multiSeller';

interface MultiSellerPopupOpenParams {
  interactionLocation: string;
  selectedVendorCode?: string;
  selectedVendorType?: ProductDetail.IVendorType;
  availableVendorCode: string[];
  availableVendorType: ProductDetail.IVendorType[];
  availableVendorCount: number;
  isBuyBoxWinner?: boolean;
}

const trackSellerPopupOpen = (event: string, {
  interactionLocation,
  selectedVendorCode,
  selectedVendorType,
  availableVendorCode,
  availableVendorType,
  availableVendorCount,
  isBuyBoxWinner
}: MultiSellerPopupOpenParams) => {
  NFA.track({
    event,
    type: TRACK_TYPE.EVENT,
    data: {
      avl_sellers_interaction_location: interactionLocation,
      selected_vendor_code: selectedVendorCode,
      selected_vendor_type: selectedVendorType,
      available_vendor_code: availableVendorCode,
      available_vendor_type: availableVendorType,
      available_vendor_count: availableVendorCount,
      is_buy_box_winner: isBuyBoxWinner
    },
  });
};

export const onMultiSellerPopupOpen = (params: MultiSellerPopupOpenParams) =>
  trackSellerPopupOpen(MULTI_SELLER_POPUP_OPEN, params);

export const onSellerDetailsPopupOpen = (params: MultiSellerPopupOpenParams) =>
  trackSellerPopupOpen(SELLER_DETAILS_POPUP_OPEN, params);
